import * as ListTypes from '../../Constants/List/ListTypes';

export const fetchList = ({
  id,
  name,
  slug,
  prevSlug,
  url,
  exist = false,
  subcatData,
  page = 1,
  search,
}) => ({
  type: ListTypes.FETCH_LIST,
  payload: {
    id,
    name,
    slug,
    prevSlug,
    url,
    exist,
    subcatData,
    page,
    search,
  },
});

export const fetchTemplate = ({ slug, page = 1, search }) => ({
  type: ListTypes.FETCH_TEMPLATE,
  payload: {
    slug,
    page,
    search,
  },
});

export const setList = (list, action) => ({
  type: ListTypes.SET_LIST,
  payload: {
    list,
    action,
  },
});

export const setSubcat = (list, id, name, slug, url) => ({
  type: ListTypes.SET_SUBCAT,
  payload: {
    list,
    id,
    name,
    slug,
    url,
  },
});

export const filterSubcat = (id) => ({
  type: ListTypes.FILTER_SUBCAT,
  payload: {
    id,
  },
});

export const resetSubcat = () => ({
  type: ListTypes.REST_SUBCAT,
});

export const fetchCat = () => ({
  type: ListTypes.FETCH_CAT,
});

export const updateCount = (count) => ({
  type: ListTypes.UPDATE_COUNT,
  payload: {
    count,
  },
});

export const appHeading = (value) => ({
  type: ListTypes.UPDATE_HEADING,
  payload: {
    value,
  },
});

export const searchUpdate = (value) => ({
  type: ListTypes.UPDATE_SEARCH,
  payload: {
    value,
  },
});

export const updateSettings = (settings) => ({
  type: ListTypes.UPDATE_SETTINGS,
  payload: {
    settings,
  },
});

export const renderOverlay = (id) => ({
  type: ListTypes.FETCH_OVERLAY,
  payload: {
    id,
  },
});

export const pageActive = (page) => ({
  type: ListTypes.ACTIVE_PAGE,
  payload: {
    page,
  },
});

export const setNavlink = (value) => ({
  type: ListTypes.SET_NAVLINK,
  payload: {
    value,
  },
});

export const setTemplate = (value) => ({
  type: ListTypes.SET_TEMPLATE,
  payload: {
    value,
  },
});
